export default __webpack_public_path__ + "static/media/grammar_pt.452fb73f.gif";